import { render, staticRenderFns } from "./ManageTags.vue?vue&type=template&id=75e94afe&"
import script from "./ManageTags.vue?vue&type=script&lang=ts&"
export * from "./ManageTags.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75e94afe')) {
      api.createRecord('75e94afe', component.options)
    } else {
      api.reload('75e94afe', component.options)
    }
    module.hot.accept("./ManageTags.vue?vue&type=template&id=75e94afe&", function () {
      api.rerender('75e94afe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/projectsettings/ManageTags.vue"
export default component.exports